<template>
  <div>
    <v-app-bar app dense clipped-left color="#F0F0F0">
      <v-app-bar-nav-icon :disabled="isUser" @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <v-container>
          <v-row no-gutters>
            <v-col justify-center>
              <v-img
                class="mx-2"
                src="@/assets/SmartOrg-removebg-preview.png"
                max-height="30"
                contain
                left
              >
              </v-img>
            </v-col>
            <v-col v-if="this.groupPlay" justify-center>
              Portfolio Simulation - Group Play ({{ this.numPlayers }} players)
            </v-col>
            <v-col v-else justify-center>
              Portfolio Simulation
            </v-col>
          </v-row>
        </v-container>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <div>{{ getDisplayName }}</div>
      <v-btn :disabled="!isUser" @click="logout" icon>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer v-if="!isUser" v-model="drawer" app clipped color="grey lighten-4">
      <v-list dense class="grey lighten-4">
        <template v-for="(item, i) in items">
          <v-row v-if="item.heading" :key="i" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col cols="6" class="text-right">
              <v-btn small text>edit</v-btn>
            </v-col>
          </v-row>
          <v-divider
            v-else-if="item.divider"
            :key="i"
            dark
            class="my-4"
          ></v-divider>
          <v-list-item
            v-else
            :key="i"
            link
            @click="$router.push({ path: item.route })"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import firebase from "firebase";
export default {
  data: () => ({
    drawer: false,
    items: [
      { icon: "mdi-account-key", text: "Administration", route: "/admin" },
      // { icon: "mdi-information-variant", text: "About", route: "/about" }
    ]
  }),
  computed: {
    groupPlay() {
      return this.$store.getters.groupPlay;
    },
    numPlayers() {
      if (this.groupPlay)
        return this.$store.getters.currentGame.players.length;
      else 
        return 0;
    },
    currentRouteName() {
      return this.$route.path;
    },
    getDisplayName() {
      return this.$store.getters['auth/displayName'];
    },
    isUser() {
      if (this.$store.getters['auth/user']) {
        return true;
      }
      else {
        return false;
      }
    }

  },
  methods: {
    logout() {
      this.$store.dispatch("listeners/stopListeners");
      this.$store.dispatch("auth/signOutAction");
      this.drawer = false;
      this.$router.push("/");
    },
    checkUser() {
      if (this.$store.getters['auth/user']) {
        return true;
      }
      else {
        return false;
      }

    }
  }
};
</script>
